<template>
    <div class="p-medical-records">
        <div class="card">
            <div class="card-header">
                <div class="font-weight-bold">{{ $locale.consultation_host }}記録一覧<span class="text-muted small">（最新15件まで）</span>
                </div>
            </div>

            <div class="card-body">
                <div v-if="medicalRecords !== null">
                    <b-table
                        :items="filteredMedicalRecords"
                        :fields="fields"
                        striped
                        hover
                        responsive>
                        <template v-slot:cell(consultation.start_time)="data">
                            {{ data.item.consultation.id }}
                        </template>

                        <template v-slot:cell(consultation.start_time)="data">
                            <div>
                                <span>
                                    {{ helper.dateForHuman( data.item.consultation.start_time, data.item.doctor.timezone, { exceptYear: helper.isCurrentYear(data.item.consultation, data.item.doctor.timezone), simpleYear: true }) }}
                                </span>
                                <span :class="helper.dayForHumanCSS(data.item.consultation.start_time , data.item.doctor.timezone)">
                                    {{ helper.dayForHuman(data.item.consultation.start_time, data.item.doctor.timezone, { bracket: true }) }}
                                </span>
                                <span class="ml-2">
                                    {{ helper.timeForHuman(data.item.consultation , data.item.doctor.timezone) }}
                                </span>
                            </div>
                            <timezone-box-jst
                                v-if="data.item.doctor.timezone !== 'Asia/Tokyo'"
                                :consultation="data.item.consultation"
                                :timezone="data.item.doctor.timezone"
                                except-year>
                            </timezone-box-jst>
                        </template>

                        <template v-slot:cell(links)="data">
                            <b-button
                                :disabled="!data.item.browsable"
                                size="sm"
                                :variant="$store.state.configs.subscription == 1 ? 'yokumiru-doctor' : 'yokumiru-dark-green'"
                                @click="linkToOtherWindow(data.item)">
                                {{ $store.state.configs.subscription == 1 ? '相談室' : '記録' }}
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import constants from '../../constants'

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            }
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                medicalRecords: null,
                fields: [
                    {
                        key: 'consultation.id',
                        label: '#',
                        sortable: false,
                    },
                    {
                        key: 'consultation.start_time',
                        label: '予約日時',
                        sortable: false,
                    },
                    {
                        key: 'consultation.medical_course.name',
                        label: `${this.$locale.consultation_host}科`,
                        sortable: false,
                    },
                    {
                        key: 'links',
                        label: '',
                        class: 'text-right',
                        sortable: false,
                    },
                ],
            };
        },

        created: function() {
            this.fetchMedicalRecords()
        },

        methods: {
            /**
             * 医師詳細モーダル表示
             *
             * @param {number} doctorId
             * @param {object} e
             */
            showModalDoctorProfile: function (doctorId, e) {
                e.preventDefault()
                bus.$emit('open-modal-doctor-profile', doctorId)
            },

            /**
             * 相談記録一覧取得
             */
            fetchMedicalRecords: function () {
                const endpoint = constants.doctor.medical_records.endpoint.base
                const query = `?user_id=${this.user.id}`

                axios.get(`${endpoint}${query}`)
                    .then(({data}) => {
                        this.medicalRecords = data.data
                    })
            },

            /**
             * 相談室の入室可能判定
             *
             * @param {number} status
             * @return {boolean}
             */
            canEnterRoom: function (status) {
                return constants.consultations.canEnterAll.includes(status)
            },

            /**
             * 診療記録URL生成
             *
             * @return {string}
             */
             linkToOtherWindow: function (medical_record) {
                if (this.$store.state.configs.subscription == 1) {
                    const url = `/doctor/consultations/${medical_record.consultation_id}`
                    const windowFeatures = 'top=100,left=100,width=1600,height=900,locationbar=0'
                    window.open(url, '_blank', windowFeatures)
                } else {
                    this.$router.push(`/doctor/medical_records/${medical_record.id}`)
                }
            },
        },

        computed: {
            /**
             * 相談室に入ることが可能な相談記録でフィルタ
             * （キャンセル、確定後医師キャンセル、医師未入室終了を除外）
             *
             * @return {array}
             */
            filteredMedicalRecords: function () {
                if (!this.medicalRecords) return []

                return this.medicalRecords.filter((record) => {
                    return this.canEnterRoom(record.consultation.status)
                })
            },
        },
    }
</script>
